import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HasSubscriptions} from '../../has-subscriptions';
import {CommunicationService} from '../../../services/communication.service';
import {ListingCategory} from '../../../classes/enums';

@Component({
  selector: 'app-detail-section',
  templateUrl: './detail-section.component.html',
  styleUrls: ['./detail-section.component.scss']
})
export class DetailSectionComponent extends HasSubscriptions implements OnInit, OnChanges {
  @Input() rows: Array<DetailStub> = [];
  @Input() hideTitle: boolean = false;
  @Input() sectionTitle: string = '';
  @Input() listingCategory: ListingCategory;
  @Input() mlsNum?: string;
  hasNonEmptyRows: boolean = true;

  constructor(private communicationService: CommunicationService) {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(s: SimpleChanges) {
    if (s.rows) this.setHasNonEmptyRows();
  }

  ListingCategory = ListingCategory;

  trackBy(index, elem: DetailStub) {
    return elem.id;
  }

  private setHasNonEmptyRows() {
    this.hasNonEmptyRows = this.rows && this.rows.some(d => !!d.value || !!d.default);
  }
}

// If row has no data and should not show 'N/A', hide it
export class DetailStub {
  category?: string;
  title: string;
  value: string;
  default?: string;
  id: string;

  constructor(data?: Partial<DetailStub>) {
    this.id = '' + Date.now() + Math.floor(Math.random() * 1000); // Generate random id
    Object.assign(this, data);
  }
}
